import React from 'react';

import { useLinkTextToAvoidInJobSearchesState, useLinkTextToAvoidInJobSearchesActions } from './LinkTextToAvoidInJobSearchesContext';
import { createLinkText } from './restApi';
import Button from '../../Shared/UI/Button/components/Button';
import ActionRow from '../../Shared/UI/ActionRow/components/ActionRow';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';

const AddLinkTextForm = () => {
  const state = useLinkTextToAvoidInJobSearchesState();
  const { onResponse, onError, setNewLinkTextValue } = useLinkTextToAvoidInJobSearchesActions();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const value = state?.newLinkTextValue?.trim() || '';
    
    if (!value) {
      onError({
        feedbackMessage: 'Value cannot be blank',
        feedbackVariant: 'error',
      });
      return;
    }

    const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

    createLinkText({
      onResponse,
      onError,
      body: {
        authenticityToken,
        value,
      },
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <ActionRow>
        <Field label="Text to Avoid" style={{ flex: 1 }}>
          <Input
            value={state?.newLinkTextValue || ''}
            onChange={(e) => setNewLinkTextValue(e.target.value)}
            placeholder="Enter text to avoid (e.g., 'Apply Now', 'Learn More')"
          />
        </Field>
        <Button type="submit">
          Add to Avoid List
        </Button>
      </ActionRow>
    </form>
  );
};

export default AddLinkTextForm;
